import {Faq} from "../../components/common/Faqs";

const faqs: Faq[] = [
    {
        question: "Is this a multivitamin?",
        answer: 'Total Human<span class="oui-sup">®</span> is more than a multivitamin. While a multivitamin helps to fill nutritional gaps, Total Human<span class="oui-sup">®</span> is providing vitamins and minerals that are targeted for specific body systems, providing more nutritional bang for your buck.'
    },
    {
        question: 'What is the benefit for taking a product like Total Human<span class="oui-sup">®</span>?',
        answer: 'Total Human<span class="oui-sup">®</span> has been curated with intention. The carefully-selected compounds take nutrition a step further, targeting specific systems that need support to help optimize your mind, muscles, bones, joints, mood, and overall energy and well-being.'
    },
    {
        question: 'Why are there so many pills?',
        answer: 'Total Human<span class="oui-sup">®</span> is designed to set the foundation for healthy daily supplementation. The Day Pack (8 pills) supports your focus, energy, endurance, and general wellness to keep you on point and performing effortlessly at your best. The Night Pack (8 pills) nourishes your body with the raw materials it needs to wake up feeling rested and energized.'
    },
    {
        question: 'Why doesn&rsquo;t Total Human<span class="oui-sup">®</span> have the same serving size as the individual bottles for the products?',
        answer: 'By design, we want Total Human<span class="oui-sup">®</span> to be a suitable option for most any user. In order to do so, we’ve included a single-dose of each supplement in each pack. This allows the user to tailor their experience. Want to keep the doses small? Take as provided. Want to maximize your supplementation? You can stack the desired supplement(s) on top of your Day or Night pack to make it a full dose. You choose the best route for you.'
    },
    {
        question: 'Is Total Human<span class="oui-sup">®</span> gender-specific?',
        answer: 'If you&rsquo;re an adult human, male or female, this product is for you!'
    },
    {
        question: 'I have a hard time taking pills, is this still for me?',
        answer: 'Any of the capsules in the Day and Night Packs can be opened and poured into liquid if taking the pills is too much. There is a gel-cap that we don&rsquo;t recommend opening, however.'
    }
];

export default faqs;
